import { KeyboardEvent } from "react";
import { cn } from "@tellescope/design-system";

export interface MedicationCardProps {
  title: string;
  dosage: string;
  statusLabel?: string;
  date?: string;
  onClick?: () => void;
  className?: string;
}

export const MedicationCard = ({ title, dosage, statusLabel, date, onClick, className }: MedicationCardProps) => {
  const handleKeyDown = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === "Enter" || event.key === " ") {
      event.preventDefault();
      onClick?.();
    }
  };

  return (
    <div
      role={onClick ? "button" : undefined}
      tabIndex={onClick ? 0 : undefined}
      onClick={onClick}
      onKeyDown={onClick ? handleKeyDown : undefined}
      className={cn(
        "flex flex-col gap-1 rounded-lg border bg-background px-4 py-3 text-left",
        onClick && "cursor-pointer transition-shadow hover:shadow-md",
        className
      )}
      data-testid="contact-details-block-item"
    >
      <p className="truncate text-sm text-foreground">{title}</p>
      <p className="truncate text-xs text-muted-foreground">{dosage}</p>

      {(statusLabel || date) && (
        <div className="mt-2 flex items-end justify-between gap-4">
          <p className="min-w-0 truncate text-xs text-muted-foreground">{statusLabel}</p>
          <p className="shrink-0 text-xs text-muted-foreground">{date}</p>
        </div>
      )}
    </div>
  );
};
